import { render, staticRenderFns } from "./CoDropdownList.vue?vue&type=template&id=33099dd4&scoped=true&"
import script from "./CoDropdownList.vue?vue&type=script&lang=js&"
export * from "./CoDropdownList.vue?vue&type=script&lang=js&"
import style0 from "./CoDropdownList.vue?vue&type=style&index=0&id=33099dd4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33099dd4",
  null
  
)

export default component.exports